import { User } from "../user";

export enum NotificationType {
  JoinEventRequestAccepted = 'JoinEventRequestAccepted',
  RequestReject = 'RequestReject',
  RemovedFromGame = 'RemovedFromGame',
  JoinRequest = 'JoinRequest',
  PlayerJoined = 'PlayerJoined',

  JoinGroupRequestAccepted = 'JoinGroupRequestAccepted',
  JoinGroupRequestRejected = 'JoinGroupRequestRejected',
  JoinGroupRequestReceived = 'JoinGroupRequestReceived',
  PlayerJoinedGroup = 'PlayerJoinedGroup',
  RemovedFromGroup = 'RemovedFromGroup',

  Review = 'Review',
  RequestGameStatus = 'RequestGameStatus',
  RequestGameReview = 'RequestGameReview',

  MessageReceived = 'MessageReceived',
  MessageDeleted = 'MessageDeleted',
}

export enum NotificationStatus {
  New = 'new',
  Read = 'read',
}

export interface Notification<T = object, R = any> {
  id: string;
  createdAt: string;
  updatedAt: string;
  type: NotificationType;
  receiverId: string;
  relatedDocument: R;
  relatedDocumentId: string;
  relatedDocumentModelName: string;
  initiator: User;
  status: NotificationStatus;
  data?: T;
  isReceived: boolean;
}

export function createNotification(params: Partial<Notification>) {
  return {} as Notification;
}
